// extracted by mini-css-extract-plugin
export default {"container":"Overlays_container__Yr1WX","cover":"Overlays_cover__GJ+uX"};